import React from "react";
import { Skeleton } from "fiver-react-ui-components";
import Voucher from "./Voucher";

const Wrapper = () => {
  return /*#__PURE__*/React.createElement(Voucher, {
    minHeight: "140px"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    skeletonWidth: "100px",
    skeletonHeight: "100px",
    margin: "0 1rem 0 0"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: "1 1 auto"
    }
  }, /*#__PURE__*/React.createElement(Skeleton, {
    display: "block",
    skeletonWidth: "180px",
    skeletonHeight: "14px",
    margin: "8px 0 14px"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    display: "block",
    skeletonWidth: "120px",
    skeletonHeight: "14px",
    margin: "0 0 14px"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    display: "block",
    skeletonWidth: "80px",
    skeletonHeight: "14px",
    margin: "0 0 0"
  })));
};

export default Wrapper;